import 'css-chunksrc/client/scenes/taskCreation/styles.scss';export default {
  "taskCreation": "_taskCreation_1eh6y_1",
  "title": "_title_1eh6y_10",
  "main": "_main_1eh6y_16",
  "buttons": "_buttons_1eh6y_30",
  "button": "_button_1eh6y_30",
  "action": "_action_1eh6y_44",
  "header": "_header_1eh6y_55",
  "icon": "_icon_1eh6y_65"
};